import { CheckIcon, CloseIcon, EditIcon } from "@chakra-ui/icons";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/input";
import { Box, Flex, Text } from "@chakra-ui/layout";
import { Button, ButtonGroup, IconButton } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { checkIfDecimal } from "../../lib/utils";

function RentalScenarioTableInput({
  inputValue,
  changeHandler,
}: {
  inputValue: string;
  changeHandler: (value: number) => void;
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(inputValue);
  const [initialValue] = useState(inputValue);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSaveClick = () => {
    changeHandler(+value);
    setIsEditing(!isEditing);
  };

  const handleCancelClick = () => {
    setValue(initialValue);
    setIsEditing(!isEditing);
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  useEffect(() => {
    if (isEditing && inputRef.current) {
      const target = inputRef.current;
      target.select();
    }
  }, [isEditing]);

  return (
    <Box maxHeight="85px">
      {isEditing ? (
        <Flex flexDir="column" alignItems="center">
          <InputGroup maxWidth="100px" size="lg">
            <Input
              ref={inputRef}
              type="number"
              value={value}
              textAlign="center"
              onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                let click = e.target as HTMLInputElement;
                click.select();
              }}
              onChange={(e) => {
                setValue(e.target.value);
              }}
            />
            <InputRightElement children="%" />
          </InputGroup>

          <ButtonGroup marginTop={2}>
            <IconButton
              size="sm"
              variant="ghost"
              aria-label="Save Changes"
              onClick={handleSaveClick}
              icon={<CheckIcon />}
            />
            <IconButton
              size="sm"
              variant="ghost"
              aria-label="Cancel"
              onClick={handleCancelClick}
              icon={<CloseIcon />}
            />
          </ButtonGroup>
        </Flex>
      ) : (
        <>
          <Text fontWeight="900" fontSize="3xl">
            {checkIfDecimal(+value)}%
          </Text>
          <Button
            size="sm"
            variant="ghost"
            aria-label="Edit LTV"
            onClick={handleEditClick}
            rightIcon={<EditIcon />}
            marginTop={2}
          >
            Edit
          </Button>
        </>
      )}
    </Box>
  );
}

export default RentalScenarioTableInput;
